import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import FullPageLoader from '@src/common/FullPageLoader';
import {getQuoteDetail} from '@src/store/slices/insurance';
import { toast } from "react-toastify";
import * as HELPER from "@src/config/helper";
import { Link } from 'react-router-dom';
import { APP_TYPE_AGENCY, REGEX_CAMEL_CASE,BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID, STATUS_CODES } from '@src/config/constant';

const QuoteDetails = () => {
  const queryParams = useParams();
  const lead_id = queryParams.id

  const [loading, setLoading] = useState(false);
  const [quoteData, setQuoteData] = useState<any>({});

  useEffect(() => {
    setLoading(true);
    getQuoteDetail({ leadId: lead_id, apptype:APP_TYPE_AGENCY }).then((resp: any) => {
        if (resp && resp.status === STATUS_CODES['success']) {
            setQuoteData(resp.data);
            setLoading(false);
            
        } else {
            setLoading(false);
        }
    }).catch((err: Error) => { setLoading(false) })
  },[lead_id]);


const downloadPolicy = async (urls:any) => {
    if (urls.length) {
        let customer_name = quoteData?.customer_name;
        let policy_number = quoteData?.policy_number;
        let formattedCustomerName = customer_name.toLowerCase()
        .replace(REGEX_CAMEL_CASE, (word:any, index:number) =>
            index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "");
        let result = `${formattedCustomerName}_${policy_number}.zip`;
        HELPER.downloadPolicy(urls,result);
    } else {
        toast.error("No File Found");
    }
};


  return (
    <React.Fragment>
      <FullPageLoader show={loading} />
      <div className="container-fluid">
          <div className="lead-top-heading p-lg-t">
              <h1>Quote Details</h1>
          </div>
          <div className='quote-outer'>
              <div className='quote-heading'>
                  <Link to='/insurance-list'><i className='ic-arrow_back'></i></Link>
                  {quoteData?.customer_name} ({quoteData?.leadId ?? quoteData?.leadId })
              </div>
              <div className='quote-list'>
                  <ul>
                      <li>
                          <div className='list-data'>
                              <span>Issue Rate</span>
                              <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.base_issue_rate ?? 0)}</label>
                          </div>
                          <div className='list-data'>
                              <span>FMV of Car</span>
                              <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.total_fmv ?? 0)}</label>
                          </div>
                      </li>
                      <li>
                          <div className='list-data'>
                              <span>Own Theft Damage</span>
                              <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.own_theft_damage ?? 0)}</label>
                          </div>
                          <div className='list-data'>
                              <span>FMV of Car</span>
                              <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.total_fmv ?? 0)}</label>
                          </div>
                      </li>
                      <li>
                          <div className='list-data'>
                              <span>PD Premium</span>
                              <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.pd_amt ?? 0)}</label>
                          </div>
                          <div className='list-data'>
                              <span>PA Premium</span>
                              <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.pa_amt ?? 0)}</label>
                          </div>
                      </li>
                      {/* if vehicle_type_id if for MOTOCYCYLE then hide AON RATE */}
                      {
                        [BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(quoteData?.vehicle_type_id) ? (
                            <>
                                <li>
                                    <div className='list-data'>
                                        <span>BI + PD + PA</span>
                                        <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.bi_pd_pa ?? 0)}</label>
                                    </div>
                                    <div className='list-data'>
                                        <span>Net Premium</span>
                                        <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.net_premium ?? 0)}</label>
                                    </div>
                                </li>
                                <li>
                                    <div className='list-data'>
                                        <span>VAT</span>
                                        <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.vat ?? 0)}</label>
                                    </div>
                                    <div className='list-data'>
                                        <span>Stamp Duty</span>
                                        <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.stamp_duty ?? 0)}</label>
                                    </div>
                                </li>
                                <li>
                                    <div className='list-data'>
                                        <span>Local Govt Taxes</span>
                                        <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.local_govt_taxes ?? 0)}</label>
                                    </div>
                                </li>
                            </>
                            ) : (
                            <>
                                <li>
                                    <div className='list-data'>
                                        <span>BI + PD + PA</span>
                                        <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.bi_pd_pa ?? 0)}</label>
                                    </div>
                                    <div className='list-data'>
                                        <span>AON Rate</span>
                                        <label>{quoteData?.quotes?.aon_rate ?? 0}%</label>
                                    </div>
                                </li>
                                <li>
                                    <div className='list-data'>
                                        <span>Net Premium</span>
                                        <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.net_premium ?? 0)}</label>
                                    </div>
                                    <div className='list-data'>
                                        <span>VAT</span>
                                        <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.vat ?? 0)}</label>
                                    </div>
                                </li>
                                <li>
                                    <div className='list-data'>
                                        <span>Stamp Duty</span>
                                        <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.stamp_duty ?? 0)}</label>
                                    </div>
                                    <div className='list-data'>
                                        <span>Local Govt Taxes</span>
                                        <label>{HELPER.addCurrencyFormatting(quoteData?.quotes?.local_govt_taxes ?? 0)}</label>
                                    </div>
                                </li>
                            </>
                            )
                        }
                  </ul>
              </div>
              <div className='gross-premium-bg'>
                  <span>{HELPER.addCurrencyFormatting(quoteData?.quotes?.gross_premium ?? 0)}</span>
                  <label>Gross Premium</label>
              </div>
              {
                quoteData.is_referral_fee_payout_saved &&
                <div className='payment-detail-txt-outer'>
                    <h4>Payment Details</h4>
                    <ul>
                        <li>
                            <label>Referral Fee scheme</label>
                            <span>Sliding Commision</span>
                        </li>
                        <li>
                            <label>Referral Fee Share</label>
                            <span>{quoteData?.referral_fee_share ?? 0} %</span>
                        </li>
                        <li>
                            <label>Referral Fee Payout Date</label>
                            <span>{quoteData?.payout_date_time ? new Date(quoteData.payout_date_time).getFullYear() : 'N/A'}</span>
                        </li>
                    </ul>
                </div>
              }
              {
                quoteData.is_policy_documents === 1 && quoteData?.policy_documents.length > 0 &&
                <div className="btn-continue">
                    <button type="button" className="btn-primary" onClick={()=>downloadPolicy(quoteData?.policy_documents??[])}>
                        <i className='ic-save_alt m-md-r'></i>
                        Download Policy
                    </button>
                </div>
              }
          </div>
      </div>
    </React.Fragment>
  );
};

export default QuoteDetails;
